import { toUploadUrl } from './uploadUrl';
import { documentFileProblem } from '../components/admissions/form/DocumentChecklistInput';

/**
 * A person's profile photo — taken at admission, kept through enrollment.
 * JPG or PNG only (what browsers and the PDF renderer can both draw), up to
 * the same 5 MB every upload is held to. Mirrors the server's photo filter.
 */

export const PHOTO_ACCEPT = '.jpg,.jpeg,.png,image/jpeg,image/png';

/** Why a chosen file can't be the photo, or null. */
export const photoFileProblem = (file: File): string | null =>
  documentFileProblem(file, { label: 'The photo', fileTypes: ['jpg', 'png'] });

/** URL of a stored photo, or undefined when there is none. */
export const personPhotoUrl = (filename?: string | null): string | undefined =>
  filename ? toUploadUrl('people', filename) : undefined;

/** The photo of a record that carries its person populated (`personId: { photoFilename }`). */
export const photoFilenameOf = (rec: { personId?: unknown } | null | undefined): string | undefined => {
  const p = rec?.personId;
  return p && typeof p === 'object' ? (p as { photoFilename?: string }).photoFilename || undefined : undefined;
};
